import { createContext, useContext, useEffect, useState } from "react";
import { AuthenticationAPI } from "@/data/authentication";
import { BookmarkAPI } from "@/data/socialize";

export const useUserContext = () => useContext(UserContext);

export const UserContext = createContext();

export const UserContextProvider = ({ children }) => {
  const [me, setMe] = useState(null);
  const [bookmarkList, setBookmarkList] = useState([]);
  const [isAuthenticated, setIsAuthenticated] = useState(false);


  const getMe = async () => {
    return await AuthenticationAPI.getMe();

  }
  const getAndSetMe = async () => {
    const { data, response } = await getMe();
    setMe(data)
  };

  const setInitialUserData = async () => {
    await getAndSetMe()
    await getAndSetBookmarks()
  }

  const initiateAuthentication = async (payload) => {
    const { response, data } = await AuthenticationAPI.authenticate(payload)
    if (response.ok) {
      handleSuccessfulAuthentication()
      return { success: true, errors: {} }
    } else {
      return { success: false, errors: { ...data }, }
    }
  }

  const logout = async () => {
    await AuthenticationAPI.logout()
    setIsAuthenticated(false)
    setMe(null)
  }

  const handleSuccessfulAuthentication = async () => {
    await setInitialUserData()
    setIsAuthenticated(true)
  }

  const getAndSetBookmarks = async () => {
    const data = await BookmarkAPI.getList()
    setBookmarkList(data)
  }

  const checkIsAuthenticated = async () => {
    try {
      const {response, data} = await AuthenticationAPI.getMe();
      if (response.ok) {
        setIsAuthenticated(true);
        setInitialUserData()
      }
    } catch (e) {
      // Do not set anything here to remove content flicker non logged in users
      // setIsAuthenticated(false);
      // setMe(null)
    }
  }


  //   const fetchMe = async (token) => {
  //     apiKit.setToken(token);
  //     const response = await userKit.getMe();
  //     if (response?.status === 200) {
  //       setMe(response.data);
  //     }
  //   };

  //   const updateMe = async (data) => {
  //     const response = await userKit.updateMe(data);
  //     if (response?.status === 200) {
  //       return response;
  //     }

  //     return response;
  //   };

  useEffect(() => {
    checkIsAuthenticated();
  }, []);

  const context = {
    // getMe,
    initiateAuthentication,
    logout,
    setInitialUserData,
    isAuthenticated,
    me,
    bookmarkList,
    getAndSetBookmarks,
    // updateMe,
  };

  return (
    <UserContext.Provider value={context}>{children}</UserContext.Provider>
  );
};
